import {gql} from '@apollo/client';

// 揽收失败原因字典，文案单一来源为服务端 order 异常字典（ExceptionDictionaries）。
// 必须用 getExceptionDictionaryAll：getExceptionDictionaryForPickup 默认过滤
// isInternalException=true（会漏 ERPU007），getExceptionDictionaryForHeadquarters
// 则过滤掉除 ERPU007 外的全部揽收码。
export const GET_PICKUP_FAILURE_REASON_DICTIONARY = gql`
    query GetPickupFailureReasonDictionary {
        getExceptionDictionaryAll {
            exceptionReasonCode
            secondaryTypeZh
            secondaryTypeEn
            secondaryTypeEs
        }
    }
`;

export interface PickupFailureReasonDictionaryEntry {
    exceptionReasonCode: string;
    secondaryTypeZh: string;
    secondaryTypeEn?: string | null;
    secondaryTypeEs?: string | null;
}

export interface GetPickupFailureReasonDictionaryResponse {
    getExceptionDictionaryAll: PickupFailureReasonDictionaryEntry[];
}
